import React from 'react';
import s from './Mice.module.css';
import Ribbon from '../../components/Ribbon/Ribbon';
import ProductCard from '../../components/ProductCard/ProductCard';
import mouses from '../../JSON/mouse.json';
import ProductCardHero from '../../components/ProductCardHero/ProductCardHero';
import Container from '../../components/Container/Container';

export default function Mice() {
  return (
    <div className={s.ProductsPage}>
      <ProductCardHero
        text={'Ігрові миші GamePRO – будь на клік попереду'}
        title={mouses[0].title}
        sendUrl={'/Images/ProductCardHeroBackgroundImages/mice.png'}
      />
      <Ribbon />
      <Container>
        <div className={s.ProductsListDescription}>
          <h2 className={s.ProductsPageTitle}>Ігрові миші</h2>
          <p className={s.ProductsPageRext}>
            Наші миші відрізняються надійною конструкцією, ергономічними
            форм-факторами і точними датчиками.
            <br />
            Завдяки поєднанню кількох кнопок, бездротових пристроїв і
            можливостей для обох рук <br /> ми обслуговуємо всіх геймеріві
            ігрові жанри.
          </p>
        </div>

        <div className={s.ProductsList}>
          <ProductCard products={mouses} />
        </div>
      </Container>
    </div>
  );
}
